import { render, staticRenderFns } from "./ConfirmationDialog.vue?vue&type=template&id=1990e674"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1990e674')) {
      api.createRecord('1990e674', component.options)
    } else {
      api.reload('1990e674', component.options)
    }
    module.hot.accept("./ConfirmationDialog.vue?vue&type=template&id=1990e674", function () {
      api.rerender('1990e674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/configuration/ConfirmationDialog.vue"
export default component.exports